function DOMLoaded() {
	console.info('CommonJS-DOMLoaded()');
	
	const footer = document.getElementById('footer');
	const footerHeight = footer ? footer.offsetHeight : 0;
	const $fixright = document.querySelector('#setting_page .setting_right');

	if ($fixright) {
		window.addEventListener('scroll', function () {
			const sT = document.documentElement.scrollTop || document.body.scrollTop;
			const val = document.documentElement.scrollHeight - window.innerHeight - footerHeight;

			if (sT >= val) {
				$fixright.classList.add('on');
			} else {
				$fixright.classList.remove('on');
			}
		});
	}

	const hTabItems = document.querySelectorAll('.hTab li');
	hTabItems.forEach(item => {
		const dropdownMenu = item.querySelector('.dropdown-menu');
		if (dropdownMenu) {
			item.addEventListener('mouseenter', () => dropdownMenu.classList.add('active'));
			item.addEventListener('mouseleave', () => dropdownMenu.classList.remove('active'));
		}
	});

	const hUserArea = document.querySelector('.hUser_area');
	if (hUserArea) {
		hUserArea.addEventListener('click', function () {
			document.querySelector('.hUser_area .dropdown-menu').classList.toggle('active');
			document.querySelector('.hUser_area .hArrow').classList.toggle('active');
		});
	}

	const mMenuBtn = document.querySelector('.mMenuBtn');
	const mCloseBtn = document.querySelector('.mclose');
	const mGnb = document.querySelector('.mGnb');

	if (mMenuBtn && mGnb) {
		mMenuBtn.addEventListener('click', () => mGnb.style.right = '0');
	}

	if (mCloseBtn && mGnb) {
		mCloseBtn.addEventListener('click', () => mGnb.style.right = '-100%');
	}

	const paginationItems = document.querySelectorAll('.pageination .num_wrap li');
	paginationItems.forEach(item => {
		item.addEventListener('click', function () {
			const i2 = Array.prototype.indexOf.call(item.parentElement.children, item);
			item.classList.add('active');
			Array.prototype.filter.call(item.parentElement.children, sibling => sibling !== item)
				.forEach(sibling => sibling.classList.remove('active'));
		});
	});

	const tab1 = document.querySelector('.c3Tab li.tab1');
	const tab2 = document.querySelector('.c3Tab li.tab2');

	if (tab1) {
		tab1.addEventListener('click', function () {
			this.classList.add('active');
			Array.prototype.filter.call(this.parentElement.children, sibling => sibling !== this)
				.forEach(sibling => sibling.classList.remove('active'));

			document.querySelector('.c3Tab_cont .box1').style.display = 'block';
			document.querySelector('.c3Tab_cont .box2').style.display = 'none';
		});
	}

	if (tab2) {
		tab2.addEventListener('click', function () {
			this.classList.add('active');
			Array.prototype.filter.call(this.parentElement.children, sibling => sibling !== this)
				.forEach(sibling => sibling.classList.remove('active'));

			document.querySelector('.c3Tab_cont .box2').style.display = 'block';
			document.querySelector('.c3Tab_cont .box1').style.display = 'none';
		});
	}

	const progressStatusItems = document.querySelectorAll('.progress_status');
	progressStatusItems.forEach(item => {
		item.addEventListener('change', function () {
			progress_status_color_chg(this);
		});

		progress_status_color_chg(item);
		if (item.value === "status3" || item.value === "status4") {
			item.setAttribute("disabled", "disabled");
		}

		item.querySelectorAll('option').forEach(option => {
			option.style.background = option.dataset.bg;
			option.style.color = option.dataset.color;
		});
	});

	const dataProsthesisForm = document.getElementById('form_prosthesis_update');
	if (dataProsthesisForm) {
		dataProsthesisForm.addEventListener('click', function (event) {
			if (event.target.classList.contains('star')) {
				event.target.classList.toggle('active');
			}

			if (event.target.classList.contains('eyes')) {
				event.target.classList.toggle('active');
			}
		});
	}

	const labMypage = document.getElementById('lab_mypage');
	if (labMypage) {
		labMypage.addEventListener('click', function (event) {
			if (event.target.classList.contains('email_edit_btn')) {
				const emailChangeBox = document.querySelector('.email_change_box');
				emailChangeBox.classList.toggle('open');
				const hasOpen = emailChangeBox.classList.contains('open');
				emailChangeBox.querySelectorAll("input[type='email'], input[type='number'], select")
					.forEach(input => input.disabled = !hasOpen);
			}

			if (event.target.classList.contains('hp_edit_btn')) {
				const phoneChangeBox = document.querySelector('.phone_change_box');
				phoneChangeBox.classList.toggle('open');
				const hasOpen = phoneChangeBox.classList.contains('open');
				phoneChangeBox.querySelectorAll("input[type='email'], input[type='number'], select")
					.forEach(input => input.disabled = !hasOpen);
			}
		});
	}

	/*
	const aiProsthesisDetail = document.getElementById('ai_prosthesis_detail');
	if (aiProsthesisDetail) {
		aiProsthesisDetail.addEventListener('click', function (event) {
			if (event.target.matches('.r_teeth div')) {
				event.target.classList.toggle('active');
			}

			const handleTeethTabClick = (index, removeIndices, addSelectors) => {
				const select = event.target;
				const parent = select.closest('.aiProContBox');
				if (select.classList.contains('active')) {
					select.classList.remove('active');
					removeIndices.forEach(i => parent.querySelector(`.teethTab li:nth-of-type(${i})`).classList.remove('active'));
					parent.querySelectorAll(addSelectors).forEach(checkbox => {
						checkbox.checked = false;
						checkbox.parentElement.classList.remove('active');
					});
				} else {
					select.classList.add('active');
					parent.querySelectorAll(addSelectors).forEach(checkbox => {
						checkbox.checked = true;
						checkbox.parentElement.classList.add('active');
					});
				}
			}

			if (event.target.matches('.teethTab li:nth-of-type(1)')) {
				handleTeethTabClick(1, [2], '.r_teeth1 input[type="checkbox"], .r_teeth2 input[type="checkbox"]');
			}

			if (event.target.matches('.teethTab li:nth-of-type(2)')) {
				const parent = event.target.closest('.aiProContBox');
				const activeClass = event.target.classList.contains('active');
				parent.querySelectorAll('.teethTab li, .r_teeth input[type="checkbox"]').forEach(el => {
					el.classList.toggle('active', !activeClass);
					if (el.type === 'checkbox') {
						el.checked = !activeClass;
						el.parentElement.classList.toggle('active', !activeClass);
					}
				});
			}

			if (event.target.matches('.teethTab li:nth-of-type(3)')) {
				handleTeethTabClick(3, [2], '.r_teeth3 input[type="checkbox"], .r_teeth4 input[type="checkbox"]');
			}
		});
	}
	*/

	const aiTab = document.querySelector('.aiTab');
	if (aiTab) {
		aiTab.querySelectorAll('li').forEach(tab => {
			tab.addEventListener('click', function (event) {
				const handleTabClick = (targetClass, showSelectors, hideSelectors) => {
					this.classList.add('active');
					Array.prototype.filter.call(this.parentElement.children, sibling => sibling !== this)
						.forEach(sibling => sibling.classList.remove('active'));
	
					document.querySelectorAll(showSelectors).forEach(el => {
						//el.style.display = 'block';
						el.classList.remove('hide');
					});
					document.querySelectorAll(hideSelectors).forEach(el => {
						//el.style.display = 'none';
						el.classList.add('hide');
					});
				}
	
				if (this.matches('.aiTabBtn1')) {
					if (window.innerWidth <= 1000) {
						handleTabClick(
							'.aiTabBtn1', 
							'.aiorder_view .aiOrderdataWrap, .aiorder_view .aiLabmemoWrap', 
							'.aiorder_view .aiTalkWrap, .aiorder_view .aiHistoryWrap'
						);
					} else {
						handleTabClick(
							'.aiTabBtn1', 
							'.aiorder_view .aiOrderdataWrap, .aiorder_view .aiTalkWrap, .aiorder_view .aiLabmemoWrap', 
							'.aiorder_view .aiHistoryWrap'
						);
					}
				}

				if (window.innerWidth <= 1000 && this.matches('.aiTabBtn2')) {
					handleTabClick(
						'.aiTabBtn2', 
						'.aiorder_view .aiTalkWrap', 
						'.aiorder_view .aiOrderdataWrap, .aiorder_view .aiLabmemoWrap, .aiorder_view .aiHistoryWrap'
					);
				}
	
				if (this.matches('.aiTabBtn3')) {
					handleTabClick(
						'.aiTabBtn3', 
						'.aiorder_view .aiHistoryWrap', 
						'.aiorder_view .aiOrderdataWrap, .aiorder_view .aiTalkWrap, .aiorder_view .aiLabmemoWrap'
					);
				}
			});
		});
	}


	/*
	const headerAiorderView = document.querySelector('.header_aiorder_view .subBtn');
	if (headerAiorderView) {
		headerAiorderView.addEventListener('click', function (event) {
			if (event.target.matches('#aEditBtn')) {
				document.querySelector('.subBtn li:nth-of-type(1)').style.display = 'none';
				document.querySelector('.subBtn li:nth-of-type(2)').style.display = 'none';
				document.querySelector('.subBtn li:nth-of-type(3)').style.display = 'none';
				document.querySelector('.subBtn li:nth-of-type(4)').style.display = 'block';
				document.querySelector('.aiorderInput_saveBtn').style.display = 'block';
			}
		});
	}
	*/

	const refuseBtn = document.querySelector("#charge_data .refuseBtn");
	if (refuseBtn) {
		refuseBtn.addEventListener('click', function () {
			document.documentElement.style.overflow = 'hidden';
			document.body.style.overflow = 'hidden';
			document.querySelector('#modal_refuse').style.display = 'block';
			document.querySelector('.modal_bg').style.display = 'block';
		});
	}

	const uRegistBtn = document.querySelector("#lab_manage_user #uRegistBtn");
	if (uRegistBtn) {
		uRegistBtn.addEventListener('click', function () {
			document.documentElement.style.overflow = 'hidden';
			document.body.style.overflow = 'hidden';
			document.querySelector('#modal_user_add').style.display = 'block';
			document.querySelector('.modal_bg').style.display = 'block';
		});
	}

	const labManageUser = document.getElementById('lab_manage_user');
	if (labManageUser) {
		labManageUser.addEventListener('mouseover', function (event) {
			if (event.target.matches('th.cols5')) {
				document.querySelector('.authorityTxt').classList.add('active');
			}
		});

		labManageUser.addEventListener('mouseout', function (event) {
			if (event.target.matches('th.cols5')) {
				document.querySelector('.authorityTxt').classList.remove('active');
			}
		});
	}

	const cont1BoardSoon = document.querySelector('.cont1Board.soon');
	if (cont1BoardSoon) {
		cont1BoardSoon.addEventListener('mouseover', () => document.querySelector('.authorityTxt').classList.add('active'));
		cont1BoardSoon.addEventListener('mouseout', () => document.querySelector('.authorityTxt').classList.remove('active'));
	}

	const matchListItems = document.querySelectorAll('.aiorder_match .match_list li');
	matchListItems.forEach(item => {
		item.addEventListener('click', function () {
			const frm = item.closest('form');
			if (frm && frm.getAttribute('action') === 'aiorder_input2.php') {
				matchListItems.forEach(li => {
					li.classList.remove('select');
					li.querySelector('.match_checkbox').checked = false;
				});
				item.classList.add('select');
				item.querySelector('.match_checkbox').checked = true;
				frm.submit();
			}
		});
	});

	const patientAge = document.getElementById("patientAge");
	if (patientAge) {
		patientAge.addEventListener("input", function () {
			if (patientAge.value.length > 3) {
				patientAge.value = patientAge.value.slice(0, 3);
			}
		});
	}

	const searchResetBtn = document.getElementById('searchResetBtn');
	if (searchResetBtn) {
		searchResetBtn.addEventListener('click', function () {
			const currentUrl = window.location.href;
			const newUrl = currentUrl.includes("type") ? currentUrl.slice(0, currentUrl.indexOf("&")) : window.location.origin + window.location.pathname;
			window.location.href = newUrl;
		});
	}

/*
	let formHasChanged = false;
	let submitted = false;

	window.onbeforeunload = function (e) {
		if (formHasChanged && !submitted) {
			const message = "You have not saved your changes.";
			e = e || window.event;
			if (e) {
				e.returnValue = message;
			}
			return message;
		}
	};

	const forms = document.querySelectorAll('form');
	if (forms.length > 0) {
		document.querySelectorAll('form input, form select, form textarea').forEach(element => {
			element.addEventListener('change', () => {
				formHasChanged = true;
				console.log('formHasChanged', formHasChanged);
			});
		});

		forms.forEach(form => {
			form.addEventListener('submit', () => {
				submitted = true;
				console.log('submitted', submitted);
			});
		});
	}
*/

	const modalCloseElements = document.querySelectorAll(".modal_close, .modal_bg");
	modalCloseElements.forEach(element => {
		element.addEventListener('click', function () {
			const scr = window.scrollY;
			document.documentElement.style.overflow = 'auto';
			document.body.style.overflow = 'auto';
			window.scrollTo(0, scr);

			document.querySelectorAll('#modal_user_add, #modal_refuse, #modal_delivery_add, #modal_delivery_edit, #match_ok, #modal_refuse_data, #modal_pw_edit')
				.forEach(modal => modal.style.display = 'none');
			const modalBg = document.querySelector('.modal_bg');
			if (modalBg) {
				modalBg.style.display = 'none';
			}
		});
	});

	

	/*
	const chargeStatus4 = document.querySelector("#lab_charge .charge_bils4");
	if (chargeStatus4) {
		chargeStatus4.addEventListener('click', function () {
			const bill_id = this.getAttribute("data_bill_id");
			const xhr = new XMLHttpRequest();
			xhr.open("POST", "/dental_common/ajax.bill_status.php", true);
			xhr.setRequestHeader("Content-Type", "application/x-www-form-urlencoded");
			xhr.onload = function () {
				if (xhr.status === 200) {
					const data = JSON.parse(xhr.responseText);
					if (data.error) {
						alert(data.error);
						return false;
					}
					document.querySelector("#bill_confirm_date").innerHTML = data.data.confirm_datetime;
					document.querySelector("#bill_confirm_user").innerHTML = data.data.confirm_user;
					document.querySelector("#bill_memo").value = data.data.bill_memo;
					document.querySelector("#publishBtn").setAttribute("onclick", `pagePopup('/charge_approval/${bill_id}');`);
					document.documentElement.style.overflow = 'hidden';
					document.body.style.overflow = 'hidden';
					document.querySelector('#modal_refuse_data').style.display = 'block';
					document.querySelector('.modal_bg').style.display = 'block';
				}
			};
			xhr.send(`id=${bill_id}`);
		});
	}
	*/

	const refuseBtnWrapYes = document.querySelector(".refuseBtnWrap .yes");
	if (refuseBtnWrapYes) {
		refuseBtnWrapYes.addEventListener('click', function () {
			const scr = window.scrollY;
			document.documentElement.style.overflow = 'auto';
			document.body.style.overflow = 'auto';
			window.scrollTo(0, scr);
			document.querySelector('#modal_refuse_data').style.display = 'none';
			document.querySelector('.modal_bg').style.display = 'none';
		});
	}

	const chk_all = document.querySelector("#chk_all");
	if (chk_all) {
		chk_all.addEventListener("click", function () {
			const chk = this.checked;
			const checkboxes = document.querySelectorAll('.paginationTable .tableItem input[type="checkbox"]');
			const visibleCheckboxes = Array.from(checkboxes).filter(checkbox => checkbox.offsetParent !== null);
			visibleCheckboxes.forEach(checkbox => checkbox.checked = chk);
		});
	}
}

function is_null(val) {
	return (!val && typeof val === 'object');
}

let openedPopups = {};

function openPopup(url, name, width, height, obj) {
	// 이미 열린 팝업창이 있는지 URL을 기준으로 확인
	for (let popupName in openedPopups) {
		if (openedPopups[popupName] && !openedPopups[popupName].closed && openedPopups[popupName].location.href === url) {
			// 이미 열린 팝업창이 있으면 포커스만 맞춤
			openedPopups[popupName].focus();
			return;
		}
	}

	// 새 팝업창을 열고 객체를 저장
	const x = Math.round(window.screenX + (window.outerWidth / 2) - (width / 2));
	const y = Math.round(window.screenY + (window.outerHeight / 2) - (height / 2));
	const popup = window.open(url, name, `width=${width},height=${height},left=${x},top=${y},toolbar=no,scrollbars=no,resizable=yes,status=no,menubar=no`);

	// 팝업창이 열리지 않은 경우 에러 처리
	if (!popup || popup.closed || typeof popup.closed === 'undefined') {
		console.error('팝업 창을 열 수 없습니다. 팝업 차단이 활성화되었는지 확인하세요.');
		return;
	}

	openedPopups[name] = popup;

	setTimeout(function () {
		popup.focus();
	}, 500);

	popup.onload = function() {
		if (typeof obj !== 'undefined') {
			const element = popup.document.querySelector(obj);
			if (element) {
				element.focus();
				console.log(element);
			}
		}
	};

	popup.onbeforeunload = function() {
		// 팝업창이 닫힐 때 객체를 삭제
		delete openedPopups[name];
	};
}

function pagePopup(url, unique) {
	const timestamp = Date.now();
	const name = unique || `덴탈클라우드${timestamp}`;
	openPopup(url, name, screen.availWidth - 500, screen.availHeight - 300);
}

function chargePopup(url) {
	openPopup(url, '청구서 발행', screen.availWidth - 400, screen.availHeight - 300);
}

function noticePopup(url) {
	openPopup(url, '공지사항', screen.availWidth - 600, screen.availHeight - 400);
}

function licensePopup(url) {
	openPopup(url, '사업자등록증 원본보기', 500, 660);
}

function originalPopup(url) {
	openPopup(url, 'AI 기공주문서 원본보기', 500, 660);
}

function printPopup(url) {
	openPopup(url, '의뢰서 출력', 794, 800);
}

function talkPopup() {
	openPopup('/dentaltalk', '덴탈TALK-메인', 400, 700);
}

function talkViewPopup(mb_id) {
	openPopup(`/dentaltalk_view/${mb_id}`, '덴탈TALK', 400, 700, '#content');
}

function aiorderViewPopup(url) {
	openPopup(url, 'AI기공주문 상세', 794, 800);
}

function aiorderHistoryPopup(url) {
	openPopup(url, 'AI기공주문 수정이력 상세', 794, 800);
}

function billPopup(url) {
	openPopup(url, '청구서 상세', screen.availWidth - 500, screen.availHeight - 300);
}
/*
function load_option(lab_id, hos_id) {
	const xhr = new XMLHttpRequest();
	xhr.open("POST", "/dental_common/ajax.get_option.php", true);
	xhr.setRequestHeader("Content-Type", "application/x-www-form-urlencoded");
	xhr.onreadystatechange = function () {
		if (xhr.readyState === 4 && xhr.status === 200) {
			const data = JSON.parse(xhr.responseText);
//console.debug(data);
			let html = "<option value=''>선택하세요</option>";
			data.list.forEach(option => {
				html += `<option>${option}</option>\r\n`;
			});
			document.querySelector("select.options").innerHTML = html;
			if (data.error) {
				alert(data.error);
			}
		}
	};
	xhr.send(`lab_mb_id=${lab_id}&hospital_mb_id=${hos_id}`);
}

function load_favorite(lab_id, hos_id) {
	const xhr = new XMLHttpRequest();
	xhr.open("POST", "/dental_common/ajax.get_favorite.php", true);
	xhr.setRequestHeader("Content-Type", "application/x-www-form-urlencoded");
	xhr.onreadystatechange = function () {
		if (xhr.readyState === 4 && xhr.status === 200) {
			const data = JSON.parse(xhr.responseText);
//console.debug(data);
			let html = '';
			data.list.forEach(item => {
				html += `<li onclick="options_detail_set(this, '${item.options}', '${item.detail}')"><p>${item.options} + ${item.detail}</p>\r\n`;
			});
			document.querySelector(".favoriteBtn").innerHTML = html;
			if (data.error) {
				alert(data.error);
			}
		}
	};
	xhr.send(`lab_mb_id=${lab_id}&hospital_mb_id=${hos_id}`);
}
*/

function progress_status_color_chg(target) {
	const selectedOption = target.querySelector('option:checked');
	if (selectedOption) {
		target.style.background = selectedOption.dataset.bg;
		target.style.color = selectedOption.dataset.color;
	}
}

function print_imgs_popup(url) {
	openPopup(url, 'print_imgs_popup', screen.availWidth - 400, screen.availHeight - 300);
}

function get_common_text(mb_type = 'lab') {
	const texts = {
		lab: {
			privacy_text: `
				<p class="agree_txtbox">
					<span>제1조 (목적)</span><br>
					이 약관은 (주)위트리(이하 “회사”라 한다)이 운영하는 덴탈클라우드(이하 “사이트”라 한다)에서 제공하는 인터넷 관련 서비스(이하 “서비스”라 한다)를 이용함에 있어 회사와 이용자의 권리, 의무 및 책임사항을 규정함을 목적으로 합니다. 이 약관은 (주)위트리(이하 “회사”라 한다)이 운영하는 덴탈클라우드(이하 “사이트”라 한다)에서 제공하는 인터넷 관련 서비스(이하 “서비스”라 한다)를 이용함에 있어 회사와 이용자의 권리, 의무 및 책임사항을 규정함을 목적으로 합니다.
				</p>`,
			agree_text: `
				<p class="agree_txtbox">
					<span>제1조 (목적)</span><br>
					이 약관은 (주)위트리(이하 “회사”라 한다)이 운영하는 덴탈클라우드(이하 “사이트”라 한다)에서 제공하는 인터넷 관련 서비스(이하 “서비스”라 한다)를 이용함에 있어 회사와 이용자의 권리, 의무 및 책임사항을 규정함을 목적으로 합니다. 이 약관은 (주)위트리(이하 “회사”라 한다)이 운영하는 덴탈클라우드(이하 “사이트”라 한다)에서 제공하는 인터넷 관련 서비스(이하 “서비스”라 한다)를 이용함에 있어 회사와 이용자의 권리, 의무 및 책임사항을 규정함을 목적으로 합니다.
				</p>`
		},
		hospital: {
			privacy_text: `
				<p class="agree_txtbox">
					<span>제1조 (목적)</span><br>
					이 약관은 (주)위트리(이하 “회사”라 한다)이 운영하는 덴탈클라우드(이하 “사이트”라 한다)에서 제공하는 인터넷 관련 서비스(이하 “서비스”라 한다)를 이용함에 있어 회사와 이용자의 권리, 의무 및 책임사항을 규정함을 목적으로 합니다. 이 약관은 (주)위트리(이하 “회사”라 한다)이 운영하는 덴탈클라우드(이하 “사이트”라 한다)에서 제공하는 인터넷 관련 서비스(이하 “서비스”라 한다)를 이용함에 있어 회사와 이용자의 권리, 의무 및 책임사항을 규정함을 목적으로 합니다.
				</p>`,
			agree_text: `
				<p class="agree_txtbox">
					<span>제1조 (목적)</span><br>
					이 약관은 (주)위트리(이하 “회사”라 한다)이 운영하는 덴탈클라우드(이하 “사이트”라 한다)에서 제공하는 인터넷 관련 서비스(이하 “서비스”라 한다)를 이용함에 있어 회사와 이용자의 권리, 의무 및 책임사항을 규정함을 목적으로 합니다. 이 약관은 (주)위트리(이하 “회사”라 한다)이 운영하는 덴탈클라우드(이하 “사이트”라 한다)에서 제공하는 인터넷 관련 서비스(이하 “서비스”라 한다)를 이용함에 있어 회사와 이용자의 권리, 의무 및 책임사항을 규정함을 목적으로 합니다.
				</p>`
		}
	};
	return texts[mb_type];
}

/*
function maxLengthCheck(event) {
	const object = event.target;

	// 숫자만 허용하는 경우, 숫자가 아닌 문자 제거
	if (object.dataset.type === 'number') {
		object.value = object.value.replace(/\D/g, '');
	}

	// maxLength 제한이 있는 경우, 입력 길이를 제한
	if (object.dataset.maxLength) {
		if (object.value.length > object.dataset.maxLength) {
			object.value = object.value.slice(0, object.dataset.maxLength);
		}
	}

	// v-model 속성 값을 읽어와 Vue 데이터 모델을 동기화
	const vModelAttr = object.getAttribute('v-model');
	if (vModelAttr) {
		// v-model 경로를 점(.)을 기준으로 분할
		const path = vModelAttr.split('.');

		// Vue의 데이터 객체에서 해당 경로를 따라가며 접근
		let target = window; // 여기서 window는 실제 Vue 인스턴스로 참조가 필요
		for (let i = 0; i < path.length - 1; i++) {
			if (target[path[i]]) {
				target = target[path[i]];
			} else {
				return; // 경로가 유효하지 않으면 함수 종료
			}
		}

		// 최종 프로퍼티 업데이트
		const key = path[path.length - 1];
		target[key] = object.value;
	}
}
*/
function maxLengthCheck(event) {
	const object = event.target;
	if (object.dataset.type === 'number') {
		// 숫자가 아닌 모든 문자를 제거
		object.value = object.value.replace(/\D/g, '');
	}

	// maxLength 속성이 있는 경우, 입력 길이를 제한
	if (object.dataset.maxLength) {
		if (object.value.length > object.dataset.maxLength) {
			object.value = object.value.slice(0, object.dataset.maxLength);
		}
	}
}

function valueCheck(event) {
	const object = event.target;
	let value = object.value.trim();
console.log(value);
	// 입력 값이 비어 있는 경우 0으로 설정
	if (value.length < 1) {
		value = '0';
	} else {
		// 숫자 변환: 앞의 불필요한 0을 제거
		value = value.replace(/^0+/, ''); // 앞의 모든 0 제거
		if (value === '') {
			value = '0'; // 모든 문자가 제거되어 빈 문자열이면 0으로 설정
		}
	}

	// DOM 업데이트
	object.value = value;
}

function removeLeadingZeroes() {
	// 모든 type="text" 및 data-type="number" 속성을 가진 input 요소를 선택합니다.
	const inputs = document.querySelectorAll('input[type="text"][data-type="number"]');

	// 각 input 요소를 반복합니다.
	inputs.forEach(input => {
		// input의 id가 phone2 또는 phone3이면 검사에서 제외합니다.
		if (input.id === 'phone2' || input.id === 'phone3') {
			return; // 이 조건을 만족하면 다음 요소로 넘어갑니다.
		}

		// input의 현재 값을 가져옵니다.
		let value = input.value;

		// 값이 두 자리 이상이고, 0으로 시작하면 앞의 0을 제거합니다.
		if (value.length > 1 && value.startsWith('0')) {
			const newValue = value.replace(/^0+/, '');
			input.value = newValue;

			// v-model에 바인딩된 form.value.xxx 값을 직접 수정합니다.
			const modelName = input.getAttribute('v-model').split('.').pop();
			form.value[modelName] = newValue;
		}
	});
}

function formSwal(tit, txt, target, type) {
console.debug('formSwal().typeof type', typeof type);
	const messageMap = {
		'cert': ' 인증 필요',
		'exist': ' 중복확인 필요',
		'self': '',
		'default': ' 입력 필요',
		'type': ' 입력형식 오류',
	};

	const textMap = {
		'cert': ' 인증 해주세요.',
		'exist': ' 중복확인 해주세요.',
		'self': '',
		'default': ' 입력해 주세요.',
		'type': ' 형식에 맞게 입력해 주세요.',
	};

	let messageType = '';
	let textType = '';

	if (typeof type !== 'undefined') {
		messageType = messageMap[type];
		textType = textMap[type];
	} else {
		messageType = messageMap['default'];
		textType = textMap['default'];
	}

	if (typeof target === 'undefined') {
		Swal.fire({
			title: tit,
			text: txt,
			icon: 'success',
			confirmButtonText: '확인',
			// allowOutsideClick: false,  // 외부 클릭 방지
			// allowEscapeKey: false,      // ESC 키 눌러서 닫기 방지
			returnFocus: false,
		});
	} else if (target === 'popup') {
		Swal.fire({
			title: tit,
			//text: txt,
			html: `<div style="word-break: keep-all;">${txt.replace(/\n/g, '<br>')}</div>`, // txt의 줄바꿈을 <br> 태그로 대체
			icon: (typeof type === 'undefined') ? 'success' : 'error',
			confirmButtonText: '확인',
			allowOutsideClick: false,  // 외부 클릭 방지
			allowEscapeKey: false,      // ESC 키 눌러서 닫기 방지
			returnFocus: false,
		}).then((result) => {
			if (result.isConfirmed) {
				setTimeout(function () {
					if(opener){
						//opener.getModels();
						opener.location.reload();
					}
					self.close();
				}, 100);
			}
		});
	} else {
		Swal.fire({
			title: `[${tit}]${messageType}`,
			text: `${txt}${textType}`,
			icon: 'error',
			confirmButtonText: '확인',
			allowOutsideClick: false,  // 외부 클릭 방지
			allowEscapeKey: false,      // ESC 키 눌러서 닫기 방지
			returnFocus: false,
		}).then((result) => {
			if (result.isConfirmed) {
				setTimeout(function () { document.querySelector(target).focus(); }, 100);
			}
		});
	}
}

function authSwal() {
	Swal.fire({
		title: '권한 없음',
		text: '접속할 수 있는 권한이 없습니다.',
		icon: 'warning',
		confirmButtonText: '확인',
		allowOutsideClick: false,  // 외부 클릭 방지
		allowEscapeKey: false,      // ESC 키 눌러서 닫기 방지
		returnFocus: false,
	}).then((result) => {
		if (result.isConfirmed) {
			setTimeout(function () { window.location.href = '/'; }, 100);
		}
	});
}

function uploadSwal(errType) {
	let tit = '파일 크기 초과';
	let txt = '지정한 파일크기(3MB)를 초과합니다.';
	if (errType === 'size') {

	} else if (errType === 'ext') {
		tit = '파일 형식 제한';
		txt = '지정한 파일만 업로드 가능합니다.';
	}

	Swal.fire({
		title: tit,
		text: txt,
		icon: 'error',
		confirmButtonText: '확인',
		// allowOutsideClick: false,  // 외부 클릭 방지
		// allowEscapeKey: false,      // ESC 키 눌러서 닫기 방지
	});
}

async function getIpAddress() {
	try {
		const response = await axios.get('https://ipinfo.io/json?token=c5091b215d2162');
		return response.data.ip;
	} catch (error) {
		console.error(error?.response?.data);
	}
}

const confirmSwal = async (title, txt, nl) => {
	let swalOption = {
		title: title,
		text: txt,
		icon: 'question',
		showCancelButton: true,
		cancelButtonText: '취소',
		cancelButtonColor: '#d33',
		confirmButtonText: '확인',
		// allowOutsideClick: false,  // 외부 클릭 방지
		// allowEscapeKey: false,      // ESC 키 눌러서 닫기 방지
		confirmButtonColor: '#3085d6',
		reverseButtons: false,
	};

	if (typeof nl === 'undefined') {
		swalOption.text = txt;
	} else {
		swalOption.html = `<div style="word-break: keep-all;">${txt.replace(/\n/g, '<br>')}</div>`; // txt의 줄바꿈을 <br> 태그로 대체
	}

	const result = await Swal.fire(swalOption);

	return result.isConfirmed;
};

const winPrint = () => {
	window.print();
}

const winClose = () => {
	if (window.opener) {
		window.close();
	} else {
		self.close();
	}
}

const dateFormatM = (dateString, today) => {
	const date = new Date(dateString);
	if (!isNaN(date)) {
		const month = String(date.getMonth() + 1).padStart(2, '0');
		return month;
	}
	if (today) {
		return new Date().toISOString().substring(5, 7);
	}
	return '';
};

const dateFormatYMD = (dateString, today) => {
	const date = new Date(dateString);
	if (!isNaN(date)) {
		const year = date.getFullYear();
		const month = String(date.getMonth() + 1).padStart(2, '0');
		const day = String(date.getDate()).padStart(2, '0');
		return `${year}-${month}-${day}`;
	}
	if (today) {
		return new Date().toISOString().slice(0, 10);
	}
	return '';
};

const dateFormatYMDHis = (dateString, today) => {
	const date = new Date(dateString);
	if (!isNaN(date)) {
		const year = date.getFullYear();
		const month = String(date.getMonth() + 1).padStart(2, '0');
		const day = String(date.getDate()).padStart(2, '0');
		const hours = String(date.getHours()).padStart(2, '0');
		const minutes = String(date.getMinutes()).padStart(2, '0');
		const seconds = String(date.getSeconds()).padStart(2, '0');
		return `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`;
	}
	if (today) {
		const now = new Date();
		const year = now.getFullYear();
		const month = String(now.getMonth() + 1).padStart(2, '0');
		const day = String(now.getDate()).padStart(2, '0');
		const hours = String(now.getHours()).padStart(2, '0');
		const minutes = String(now.getMinutes()).padStart(2, '0');
		const seconds = String(now.getSeconds()).padStart(2, '0');
		return `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`;
	}
	return '';
};

function isValidDate(dateString) {
	const dateRegex = /^\d{4}-\d{2}-\d{2}$/;

	if (!dateRegex.test(dateString)) {
		return false;
	}

	const date = new Date(dateString);
	if (!(date instanceof Date) || isNaN(date)) {
		return false;
	}

	// 날짜 범위 검증
	const minDate = new Date('1900-01-01'); // 최소 허용 날짜
	const today = new Date();
	const maxDate = new Date(today.getFullYear(), today.getMonth() + 6, today.getDate()); // 오늘로부터 6개월 뒤

	if (date < minDate || date > maxDate) {
		return false;
	}

	return true;
}

function isValidDateTime(dateTimeString) {
	const dateRegex = /^\d{4}-\d{2}-\d{2}$/;
	const dateTimeRegex = /^\d{4}-\d{2}-\d{2}T\d{2}:\d{2}:\d{2}(\.\d{3})?Z?$/;

	if (!dateRegex.test(dateTimeString) && !dateTimeRegex.test(dateTimeString)) {
		return false;
	}

	const date = new Date(dateTimeString);
	if (!(date instanceof Date) || isNaN(date)) {
		return false;
	}

	// 날짜 범위 검증
	const minDate = new Date('1900-01-01T00:00:00'); // 최소 허용 날짜와 시간을 설정
	const today = new Date();
	const maxDate = new Date(today.getFullYear(), today.getMonth() + 6, today.getDate()); // 오늘로부터 6개월 뒤

	if (date < minDate || date > maxDate) {
		return false;
	}

	return true;
}


function calculateDDay(targetDate) {
	const currentDate = new Date();
	const target = new Date(targetDate);

	const diffTime = target - currentDate;
	const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24));

	return diffDays < 0 ? `D+${Math.abs(diffDays)}` : `D-${Math.abs(diffDays)}`;
}

function getCurrentDateTime() {
	const now = new Date();

	const year = now.getFullYear();
	const month = String(now.getMonth() + 1).padStart(2, '0'); // 월은 0부터 시작하므로 1을 더함
	const day = String(now.getDate()).padStart(2, '0');

	const hours = String(now.getHours()).padStart(2, '0');
	const minutes = String(now.getMinutes()).padStart(2, '0');
	const seconds = String(now.getSeconds()).padStart(2, '0');

	return `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`;
}

function stripTags(str) {
	// HTML 태그를 제거하는 함수
	const doc = new DOMParser().parseFromString(str, "text/html");
	return doc.documentElement.textContent;
}

const replaceTag = (str) => {
	return str.replace(/&amp;/g, '&').replace(/&lt;/g, '<').replace(/&gt;/g, '>');
};

function replaceToBr(str) {
	// \r\n을 <br>로 교체하는 함수
	return str.replace(/(\r\n|\n|\r)/g, "<br>");
}

function arraySum(array) {
	// array가 undefined일 경우 빈 배열로 대체
	return (array || []).reduce((acc, curr) => Number(acc) + Number(curr), 0);
}

function forceDownload(url, fileName) {
	const xhr = new XMLHttpRequest();
	xhr.open('GET', url, true);
	xhr.responseType = 'blob';
	xhr.onload = function () {
		const url = window.URL.createObjectURL(xhr.response);
		const a = document.createElement('a');
		a.href = url;
		a.download = fileName;
		document.body.appendChild(a);
		a.click();
		a.remove();
		window.URL.revokeObjectURL(url);
	};
	xhr.send();
}

function isValidBase64(str) {
	return str.startsWith("/9j/") && (str.endsWith("=") || str.endsWith("=="));
};

function sanitizeJSONString(jsonString) {
	return jsonString.replace(/[\r\t]/g, " "); // Replace control characters with space or another valid character
}

export {
	DOMLoaded, 
	is_null, pagePopup, chargePopup, noticePopup, licensePopup, originalPopup,
	printPopup, talkPopup, talkViewPopup, aiorderViewPopup, aiorderHistoryPopup, billPopup, //load_option, load_favorite,
	progress_status_color_chg, print_imgs_popup, get_common_text, maxLengthCheck, valueCheck,
	removeLeadingZeroes, formSwal, authSwal, uploadSwal, getIpAddress, confirmSwal, winPrint, winClose, dateFormatM, dateFormatYMD, dateFormatYMDHis, isValidDate, isValidDateTime,
	calculateDDay, getCurrentDateTime, stripTags, replaceTag, replaceToBr, arraySum, forceDownload, isValidBase64, sanitizeJSONString
};